import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
import { getAppHeader } from "../../../configs/config";
import { getForeClosureDetails } from "../../../configs/utils";
import { REPAYMENT_COLLECTION_TYPE } from "../../../configs/constants";
import { Platform } from "react-native";
export const goBack = async (action, _datastore, { goBack, navigateWithClear }) => {
    await navigateWithClear(ROUTE.FORECLOSURE_NEW);
};
export const releaseCollateral = async (action, _datastore, { goBack, navigate, network, navigateWithClear, instrumentTrack }) => {
    instrumentTrack('RELEASE_COLLATERAL_BUTTON_CLICKED');
    const user = await SharedPropsService.getUser();
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
    };
    const creditResponse = await network
        .get(`${api.getCollateral}${user.linkedCredits[0].creditId}`, requestOptions);
    if (creditResponse.status === 200) {
        const tempData = creditResponse.data;
        await SharedPropsService.setPortfolioData(creditResponse.data);
        if (Platform.OS === 'ios') {
            await navigateWithClear(ROUTE.VIEW_PORTFOLIO_DETAIL, { tempData: tempData, isFromForeclosureRasonPage: true });
        }
        else
            await navigate(ROUTE.VIEW_PORTFOLIO_DETAIL, { tempData: tempData });
    }
};
export const navigateToDashboard = async (action, _datastore, { goBack, navigateWithClear, instrumentTrack }) => {
    instrumentTrack('KEEP_ACCOUNT_ACTIVE_BUTTON_CLICKED', {
        source_page: 'intervention_modal',
    });
    await navigateWithClear(ROUTE.DASHBOARD);
};
export const forecloseAccount = async (action, _datastore, { goBack, navigate, network, navigateWithClear, instrumentTrack }) => {
    const user = await SharedPropsService.getUser();
    const creditId = user?.linkedCredits[0]?.creditId;
    instrumentTrack('STILL_WANT_TO_CLOSE_ACCOUNT_BUTTON_CLICKED', {
        source_page: 'intervention_modal',
    });
    const getForeClosureData = await getForeClosureDetails(network, {
        overrideCache: true
    });
    if (getForeClosureData) {
        const netPayable = getForeClosureData?.netPayable;
        if (netPayable > 0 || netPayable < 0) {
            if (Platform.OS === 'ios') {
                await navigateWithClear(ROUTE.CONFIRM_AND_PAYMENT, { foreClosureData: getForeClosureData, selectedAmount: netPayable, collectionType: REPAYMENT_COLLECTION_TYPE.FORECLOSURE, isFromForeclosureFlow: true, isFromForeclosureRasonPage: true });
            }
            else
                navigate(ROUTE.CONFIRM_AND_PAYMENT, { foreClosureData: getForeClosureData, selectedAmount: netPayable, collectionType: REPAYMENT_COLLECTION_TYPE.FORECLOSURE, isFromForeclosureFlow: true });
        }
        else if (netPayable === 0) {
            const getLoanDetails = await network.get(`${api.getLoanDetails}${creditId}`, { headers: await getAppHeader() });
            if (Platform.OS === 'ios') {
                await navigateWithClear(ROUTE.CONFIRM_LOAN_DETAILS, { getLoanDetails, isFromForeclosureRasonPage: true, isFromForeclosureFlow: true });
            }
            else
                await navigate(ROUTE.CONFIRM_LOAN_DETAILS, { getLoanDetails });
        }
    }
};
export const clearDues = async (action, _datastore, { goBack, navigate, network, navigateWithClear, instrumentTrack }) => {
    instrumentTrack('CLEAR_ALL_DUES_BUTTON_CLICKED');
    const getForeClosureData = await getForeClosureDetails(network, {
        overrideCache: true
    });
    if (getForeClosureData) {
        const netPayable = getForeClosureData?.netPayable;
        if (Platform.OS === 'ios') {
            await navigateWithClear(ROUTE.CONFIRM_AND_PAYMENT, { foreClosureData: getForeClosureData, selectedAmount: netPayable, isFromForeclosureFlow: true, collectionType: REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT, isFromForeclosureRasonPage: true });
        }
        else
            await navigate(ROUTE.CONFIRM_AND_PAYMENT, { foreClosureData: getForeClosureData, selectedAmount: netPayable, isFromForeclosureFlow: true, collectionType: REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT });
    }
};
export const storeUserFeedback = async (action, _datastore, { goBack, navigateWithClear, instrumentTrack }) => {
    const userRemarks = action?.payload?.remarks;
    const userReason = action?.payload?.reason;
    instrumentTrack('ACCOUNT_CLOSURE_REASON_SELECTED', {
        selected_reason: userReason
    });
    await SharedPropsService.setCustomerReason(userReason);
    await SharedPropsService.setCustomerRemarks(userRemarks);
};
